/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "apply-button-label": [{
    "type": 0,
    "value": "Apply"
  }],
  "cancel-button-label": [{
    "type": 0,
    "value": "Cancel"
  }],
  "change-country-button-label": [{
    "type": 0,
    "value": "Change country"
  }],
  "clear-all-button-label": [{
    "type": 0,
    "value": "Clear all"
  }],
  "clear-all-shown-button-label": [{
    "type": 0,
    "value": "Clear all shown"
  }],
  "country-count-label": [{
    "offset": 0,
    "options": {
      "=0": {
        "value": [{
          "type": 0,
          "value": "No countries"
        }]
      },
      "one": {
        "value": [{
          "type": 0,
          "value": "One country"
        }]
      },
      "other": {
        "value": [{
          "type": 1,
          "value": "n"
        }, {
          "type": 0,
          "value": " countries"
        }]
      }
    },
    "pluralType": "cardinal",
    "type": 6,
    "value": "n"
  }],
  "done-button-label": [{
    "type": 0,
    "value": "Done"
  }],
  "manage-country-list-link": [{
    "type": 0,
    "value": "Manage country list"
  }],
  "multi-countries-group-label": [{
    "type": 0,
    "value": "Select countries"
  }],
  "option-label-AE": [{
    "type": 0,
    "value": "United Arab Emirates"
  }],
  "option-label-AR": [{
    "type": 0,
    "value": "Argentina"
  }],
  "option-label-AT": [{
    "type": 0,
    "value": "Austria"
  }],
  "option-label-AU": [{
    "type": 0,
    "value": "Australia"
  }],
  "option-label-BE": [{
    "type": 0,
    "value": "Belgium"
  }],
  "option-label-BG": [{
    "type": 0,
    "value": "Bulgaria"
  }],
  "option-label-BH": [{
    "type": 0,
    "value": "Bahrain"
  }],
  "option-label-BR": [{
    "type": 0,
    "value": "Brazil"
  }],
  "option-label-CA": [{
    "type": 0,
    "value": "Canada"
  }],
  "option-label-CH": [{
    "type": 0,
    "value": "Switzerland"
  }],
  "option-label-CL": [{
    "type": 0,
    "value": "Chile"
  }],
  "option-label-CN": [{
    "type": 0,
    "value": "China"
  }],
  "option-label-CO": [{
    "type": 0,
    "value": "Colombia"
  }],
  "option-label-CR": [{
    "type": 0,
    "value": "Costa Rica"
  }],
  "option-label-CY": [{
    "type": 0,
    "value": "Cyprus"
  }],
  "option-label-CZ": [{
    "type": 0,
    "value": "Czech Republic"
  }],
  "option-label-DE": [{
    "type": 0,
    "value": "Germany"
  }],
  "option-label-DK": [{
    "type": 0,
    "value": "Denmark"
  }],
  "option-label-DO": [{
    "type": 0,
    "value": "Dominican Republic"
  }],
  "option-label-DZ": [{
    "type": 0,
    "value": "Algeria"
  }],
  "option-label-EC": [{
    "type": 0,
    "value": "Ecuador"
  }],
  "option-label-EE": [{
    "type": 0,
    "value": "Estonia"
  }],
  "option-label-EG": [{
    "type": 0,
    "value": "Egypt"
  }],
  "option-label-ES": [{
    "type": 0,
    "value": "Spain"
  }],
  "option-label-FI": [{
    "type": 0,
    "value": "Finland"
  }],
  "option-label-FR": [{
    "type": 0,
    "value": "France"
  }],
  "option-label-GB": [{
    "type": 0,
    "value": "United Kingdom"
  }],
  "option-label-GR": [{
    "type": 0,
    "value": "Greece"
  }],
  "option-label-GT": [{
    "type": 0,
    "value": "Guatemala"
  }],
  "option-label-HK": [{
    "type": 0,
    "value": "Hong Kong"
  }],
  "option-label-HN": [{
    "type": 0,
    "value": "Honduras"
  }],
  "option-label-HR": [{
    "type": 0,
    "value": "Croatia"
  }],
  "option-label-HU": [{
    "type": 0,
    "value": "Hungary"
  }],
  "option-label-ID": [{
    "type": 0,
    "value": "Indonesia"
  }],
  "option-label-IE": [{
    "type": 0,
    "value": "Ireland"
  }],
  "option-label-IL": [{
    "type": 0,
    "value": "Israel"
  }],
  "option-label-IN": [{
    "type": 0,
    "value": "India"
  }],
  "option-label-IT": [{
    "type": 0,
    "value": "Italy"
  }],
  "option-label-JM": [{
    "type": 0,
    "value": "Jamaica"
  }],
  "option-label-JP": [{
    "type": 0,
    "value": "Japan"
  }],
  "option-label-KR": [{
    "type": 0,
    "value": "Korea"
  }],
  "option-label-KW": [{
    "type": 0,
    "value": "Kuwait"
  }],
  "option-label-LT": [{
    "type": 0,
    "value": "Lithuania"
  }],
  "option-label-LU": [{
    "type": 0,
    "value": "Luxembourg"
  }],
  "option-label-LV": [{
    "type": 0,
    "value": "Latvia"
  }],
  "option-label-MA": [{
    "type": 0,
    "value": "Morocco"
  }],
  "option-label-MX": [{
    "type": 0,
    "value": "Mexico"
  }],
  "option-label-MY": [{
    "type": 0,
    "value": "Malaysia"
  }],
  "option-label-NL": [{
    "type": 0,
    "value": "Netherlands"
  }],
  "option-label-NO": [{
    "type": 0,
    "value": "Norway"
  }],
  "option-label-NZ": [{
    "type": 0,
    "value": "New Zealand"
  }],
  "option-label-PA": [{
    "type": 0,
    "value": "Panama"
  }],
  "option-label-PE": [{
    "type": 0,
    "value": "Peru"
  }],
  "option-label-PH": [{
    "type": 0,
    "value": "Philippines"
  }],
  "option-label-PK": [{
    "type": 0,
    "value": "Pakistan"
  }],
  "option-label-PL": [{
    "type": 0,
    "value": "Poland"
  }],
  "option-label-PR": [{
    "type": 0,
    "value": "Puerto Rico"
  }],
  "option-label-PT": [{
    "type": 0,
    "value": "Portugal"
  }],
  "option-label-PY": [{
    "type": 0,
    "value": "Paraguay"
  }],
  "option-label-QA": [{
    "type": 0,
    "value": "Qatar"
  }],
  "option-label-RO": [{
    "type": 0,
    "value": "Romania"
  }],
  "option-label-SA": [{
    "type": 0,
    "value": "Saudi Arabia"
  }],
  "option-label-SE": [{
    "type": 0,
    "value": "Sweden"
  }],
  "option-label-SG": [{
    "type": 0,
    "value": "Singapore"
  }],
  "option-label-SK": [{
    "type": 0,
    "value": "Slovakia"
  }],
  "option-label-SV": [{
    "type": 0,
    "value": "El Salvador"
  }],
  "option-label-TH": [{
    "type": 0,
    "value": "Thailand"
  }],
  "option-label-TN": [{
    "type": 0,
    "value": "Tunisia"
  }],
  "option-label-TR": [{
    "type": 0,
    "value": "Türkiye"
  }],
  "option-label-TW": [{
    "type": 0,
    "value": "Taiwan"
  }],
  "option-label-US": [{
    "type": 0,
    "value": "United States"
  }],
  "option-label-UY": [{
    "type": 0,
    "value": "Uruguay"
  }],
  "option-label-VN": [{
    "type": 0,
    "value": "Viet Nam"
  }],
  "option-label-ZA": [{
    "type": 0,
    "value": "South Africa"
  }],
  "remove-button-label": [{
    "type": 0,
    "value": "Remove"
  }],
  "search-clear-button-label": [{
    "type": 0,
    "value": "Clear search terms"
  }],
  "search-countries-placeholder": [{
    "type": 0,
    "value": "Search countries"
  }],
  "search-no-results": [{
    "type": 0,
    "value": "Country not available. Search again."
  }],
  "select-all-button-label": [{
    "type": 0,
    "value": "Select all"
  }],
  "select-all-shown-button-label": [{
    "type": 0,
    "value": "Select all shown"
  }],
  "single-country-group-label": [{
    "type": 0,
    "value": "Select a country"
  }],
  "trigger-button-choose-country-label": [{
    "type": 0,
    "value": "Choose a country"
  }],
  "trigger-button-label": [{
    "type": 0,
    "value": "Country: "
  }, {
    "type": 1,
    "value": "selectedCountry"
  }],
  "trigger-button-number-selected-label": [{
    "type": 0,
    "value": "("
  }, {
    "type": 1,
    "value": "n"
  }, {
    "type": 0,
    "value": " selected) "
  }, {
    "type": 1,
    "value": "commaSeparatedCountriesList"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D };
//# sourceMappingURL=en-US-kmEIp7ud.js.map
